var slideIndex = 1;

function plusSlides(n) {
  showSlides(slideIndex += n);
}

function currentSlide(n) {
  showSlides(slideIndex = n);
}

function showSlides(n) {
  //alert('showslides('+ n +')\nslideIndex='+slideIndex);
  var i;
  var slides = document.getElementsByClassName("mySlides");
  var dots = document.getElementsByClassName("dot");
  if (n === undefined) {
    n = ++slideIndex;
  }
  if (n > slides.length) {
    slideIndex = 1;
  }
  if (n < 1) {
    slideIndex = slides.length;
  }
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  for (i = 0; i < dots.length; i++) {
    dots[i].className = dots[i].className.replace(" active", "");
  }
  slides[slideIndex - 1].style.display = "block";
  dots[slideIndex - 1].className += " active";

  //setTimeout(showSlides, 5000); // Change image every 10 seconds
} 

 

(function($) {
    $(document).ready(function() {
        
        $('.slider-hero').slick({
            autoplay:true,
            autoplaySpeed:5000,
            arrows:true,
            dots: false,
            infinite: true,
            cssEase: 'linear',
            swipe: true,
            prevArrow: '<span class="prev-arrow"><i class="fa fa-angle-left fa-2x" aria-hidden="true"></i></span>',
            nextArrow: '<span class="next-arrow"><i class="fa fa-angle-right fa-2x" aria-hidden="true"></i></span>'
        });
    });
	
})( jQuery );


